import clsx from "clsx";
import React from "react";
import { ErrorMessageProps } from "./FormFields.interfaces";
import styles from "./FormFields.module.scss";

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  id,
  message,
  hasError,
  isActive,
}) => {
  if (!hasError) return null;

  const messages = Array.isArray(message) ? message : [message];

  return (
    <div className={styles["message-wrapper"]} id={id}>
      {messages.map((msg, index) => (
        <p
          key={index}
          className={clsx(styles.message, isActive && styles.active)}
        >
          {isActive && index === 0 && <span className="sr-only">Error:</span>}
          {msg}
        </p>
      ))}
    </div>
  );
};

export default ErrorMessage;
